import React from 'react'
import { connect, getIn, FormikContextType } from 'formik'
import { t } from '@local/translations'
import { TextInputField } from '@toasttab/buffet-pui-forms'

import { Fieldset } from '@local/do-secundo-fieldset'

interface Props {
  label: string
  maxLength: number
  name: string
  formik: FormikContextType<any>
  placeholder: string
  disabled: boolean
}

const NameFieldComponent: React.FC<Props> = ({
  label,
  maxLength,
  name,
  formik,
  placeholder,
  disabled
}) => {
  const current = getIn(formik.values, name).length
  const msg = t('modifier-body.character-count', { current, maxLength })
  const instructions = (
    <>
      <span
        data-testid='modifier-name-field-max-length'
        className={'type-default'}
      >
        {t('modifier-body.character-limit', { maxLength })}
      </span>
      {current ? (
        <span data-testid='modifier-name-field-count'>{msg}</span>
      ) : null}
    </>
  )
  return (
    <Fieldset label={label} instructions={instructions} name={name}>
      <TextInputField
        id='nameField'
        testId='modifier-name-field'
        name={name}
        type='text'
        maxLength={maxLength}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Fieldset>
  )
}

export const NameField = connect<Omit<Props, 'formik'>>(NameFieldComponent)
